/**
 * Verifies if an application can use DOM.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "canUseDOM", {
    enumerable: true,
    get: function() {
        return canUseDOM;
    }
});
function canUseDOM() {
    return typeof window !== 'undefined' && !!(window.document && window.document.createElement);
}
